import styled, { css } from 'styled-components';
import { Header } from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';
import media from 'src/styles/Media.styled';

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};

    ${media.mobileDevice`
        width: 95%;
        margin: 0px;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : ' ')};
        
    `}
`;
export const MainContainerItems = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding-left: ${({ paddingLeft }) => paddingLeft};
    margin-left: ${({ marginLeft }) => marginLeft};
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};

    ${media.mobileDevice`
        width: 100%;
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
        padding-left:0px;
        margin-left:0;
    `}
`;
export const ShippingOrderContainer = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 8px;
    flex-direction: column;
    flex-wrap: wrap;
    padding-left: ${({ paddingLeft }) => paddingLeft};
    margin-left: ${({ marginLeft }) => marginLeft};
    ${media.mobileDevice`
        width: 95%;
        padding-left:0px;
        margin-left:0;        
        margin-top: 10px
    `};
`;
export const ShippingOrderNo = styled.p`
    margin: ${({ orderNumber, orderStatus }) =>
        orderNumber ? '0 0 5px 0' : orderStatus && '0 0 8px 0'};
    font-family: ${({ orderNumber, orderStatus }) =>
        orderNumber
            ? 'AvenirNextWorld Demi'
            : orderStatus && 'AvenirNextWorld Regular'};
    font-size: ${({ orderNumber, orderStatus }) =>
        orderNumber ? '14px' : orderStatus && '15px'};
    line-height: 20px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;

    ${({ orderNumber }) =>
        orderNumber &&
        css`
            &:before {
                // content: 'Order #';
            }
        `};
`;

export const SurgeryHeader = styled(Header)`
    font-size: 12px;
    padding: ${({ padding }) => (padding ? padding : '8px 20px 8px 20px')};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    margin-top: 5px;
    height: ${({ headerHeight }) => headerHeight};
    padding-left: ${({ paddingLeft }) => paddingLeft};
    margin-bottom: 10px;
    margin-left: ${({ marginLeft }) => marginLeft};
    height: 30px;

    ${media.mobileDevice`
        margin-left:${({ mbMarginLeft }) =>
            mbMarginLeft ? mbMarginLeft : '-11px'};
        margin-right: -27px;
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '9px'}; 
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : 'calc(100% + 54px)')};
        height: 31px;
        line-height:20px;
        margin-bottom:10px;
    `};
`;
